/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *  - UNSPECIFIED: Default value if not present.
 *  - RAW: Display value as its raw format.
 *  - PERCENTAGE: Display value in percentage format.
 * @export
 */
export const RunMetricFormat = {
  UNSPECIFIED: 'UNSPECIFIED',
  RAW: 'RAW',
  PERCENTAGE: 'PERCENTAGE',
} as const;
export type RunMetricFormat = (typeof RunMetricFormat)[keyof typeof RunMetricFormat];

export function instanceOfRunMetricFormat(value: any): boolean {
  for (const key in RunMetricFormat) {
    if (Object.prototype.hasOwnProperty.call(RunMetricFormat, key)) {
      if (RunMetricFormat[key as keyof typeof RunMetricFormat] === value) {
        return true;
      }
    }
  }
  return false;
}

export function RunMetricFormatFromJSON(json: any): RunMetricFormat {
  return RunMetricFormatFromJSONTyped(json, false);
}

export function RunMetricFormatFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RunMetricFormat {
  return json as RunMetricFormat;
}

export function RunMetricFormatToJSON(value?: RunMetricFormat | null): any {
  return value as any;
}

export function RunMetricFormatToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): RunMetricFormat {
  return value as RunMetricFormat;
}
